/* jshint ignore:start */

if (typeof (RP6) == 'undefined') {
    RP6 = {};
}

//if (typeof (isStep5Removed) == 'undefined') {
//    isStep5Removed = false;
//}

RP6.home = {
    init: function () {
        if ($('.wrap--facts').length) {
            RP6.general.animateStats('.wrap--facts', '.card--fact', '.spnNumber', '.spnNumberHide');
        }
        if ($('.card--property .js-hover').length) {
            RP6.general.imageButtonHoverState();
        }
    }
};

RP6.general = {
    init: function () {
        $(document).ready(function () {
            $('.selectpicker').selectpicker({
                dropupAuto: false,
                iconBase: ''
            });

            // Enable native mobile menu
            //if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
            //    $('.selectpicker').selectpicker('mobile');
            //}
        });
    },
    getSpecificVars: function (section) {
        if (!section || !RP6_VARS) return {};
        const specificVars = {};
        const specificProps = Object.getOwnPropertyNames(RP6_VARS)
            .filter(prop => prop.indexOf(section + "_") !== -1);

        specificProps.forEach(specificPropName => {
            const defaultPropName = specificPropName.replace(section + "_", "");
            specificVars[defaultPropName] = RP6_VARS[specificPropName];
        });

        return specificVars;
    },
    slideshow: function () {
        if ($('.wrap--carousel .carousel-inner').length) {
            const JUMBOTRON_Vars = RP6.general.getSpecificVars("JUMBOTRON");
            RP6.slideshow.init('.wrap--carousel .carousel-inner', JUMBOTRON_Vars);
        }

        if ($('.carousel--spotlight .carousel-inner').length) {
            const PIDK_Vars = RP6.general.getSpecificVars("PIDK");
            RP6.slideshow.init('.carousel--spotlight .carousel-inner', PIDK_Vars);
        }

        if ($('#carousel-testimonials .carousel-inner').length) {
            const TESTIMONIALS_Vars = RP6.general.getSpecificVars("TESTIMONIALS");
            RP6.slideshow.init('#carousel-testimonials .carousel-inner', TESTIMONIALS_Vars);
        }

        if ($('#carousel-news .carousel-inner').length) {
            const NEWS_Vars = RP6.general.getSpecificVars("NEWS");
            RP6.slideshow.init('#carousel-news .carousel-inner', NEWS_Vars);
        }
    },
    noSearchResults: function () {
        if ($(".no-results").length) {
            //$("body").addClass("has-no-results");
        }
    },
    sidebarFixed: function (bottom) {
        var stickyElements = document.querySelectorAll('.is-fixed');
        Stickyfill.add(stickyElements);
    },
    bootstrapDropdownHover: function () {
        function toggleDropdown(e) {
            const _d = $(e.target).closest('.nav--primary > .dropdown'),
                _m = $('.dropdown-menu--nav', _d);
            setTimeout(function () {
                const shouldOpen = e.type !== 'click' && _d.is(':hover');
                _m.toggleClass('show', shouldOpen);
                _d.toggleClass('show', shouldOpen);
                $('[data-toggle="dropdown"]', _d).attr('aria-expanded', shouldOpen);
            }, e.type === 'mouseleave' ? 50 : 0);
        }

        $('body')
            .on('mouseenter mouseleave', '.nav--primary > .dropdown', toggleDropdown)
            .on('click', '.dropdown-menu a', toggleDropdown);
    },
    imageButtonHoverState: function () {
        var parent, button;
        $(".card--property .js-hover").hover(function () {
            parent = $(this).closest(".card--property");
            button = $(parent).find(".btn--more");
            $(button).addClass("is-active");
        },
            function () {
                $(button).removeClass("is-active");
            });
    },
    animateStats: function (parentContainer, container, elFrom, elTo) {
        var stopFinding = false;
        if ($(window).width() > 767 && !RP6_VARS.stopAnimationStats) {

            var animate = function animate() {
                var foundEl = RP6.general.elementInView(parentContainer);
                if (foundEl && !stopFinding) {
                    stopFinding = true;
                    var $cont = $(container);
                    $cont.each(function () {
                        $(this).find(elFrom).animateNumber({
                            number: $(this).parent().find(elTo).text(),
                            easing: 'easeInQuad'
                        }, 5000);
                    });
                }
            }

            $(window).scroll(function () {
                animate();
            });

            animate();
        } else {
            $('.spnNumber').hide();
            $('.spnNumberHide').show();
        }
    },
    elementInView: function (el) {
        const scroll = window.scrollY || window.pageYOffset;
        const boundsTop = $(el)[0].getBoundingClientRect().top + scroll;

        const viewport = {
            top: scroll,
            bottom: scroll + window.innerHeight,
        };

        const bounds = {
            top: boundsTop,
            bottom: boundsTop + el.clientHeight,
        };

        return (bounds.bottom >= viewport.top && bounds.bottom <= viewport.bottom) ||
            (bounds.top <= viewport.bottom && bounds.top >= viewport.top);
    },
    floatLabels: () => {
        const init = () => {
            const $floatingContainers = document.querySelectorAll('.floating-label');
            $floatingContainers.forEach(el => {
                el.querySelector('input, textarea').value && el.classList.add('floating');
                bindEvents(el);
            });
        };

        const handleFocus = ({ target }) => {
            target.parentNode.classList.add('floating');
        };

        const handleBlur = ({ target }) => {
            !target.value && target.parentNode.classList.remove('floating');
        };

        const bindEvents = el => {
            const $input = el.querySelector('input, textarea');
            $input.addEventListener('focus', handleFocus);
            $input.addEventListener('blur', handleBlur);
        };

        init();
    },
    backToTop: function () {
        $(window).scroll(function () {
            if ($(this).scrollTop() >= 50) {
                $('.js-backtotop').fadeIn(200);
            } else {
                $('.js-backtotop').fadeOut(200);
            }
        });
        $('.js-backtotop').click(function () {
            $('body,html').animate({
                scrollTop: 0
            }, 500);
        });
    },
    checkCarouselIndicators: function () {
        function getLength() {
            var total = $('.carousel-indicators li').length;
            if (total == 1) {
                $('.carousel-indicators').addClass('d-none');
            }
        }
        $(window).on('resize load', function () {
            getLength();
        });
    },
    expandButton: function () {
        $('#expandSearch').on('hide.bs.collapse', function () {
            var text = $("#expand-button").data("expand");
            $(".expand--status").html(text);
            $("#expand-button .icon").removeClass("icon--min");
            $("#expand-button .icon").addClass("icon--plus");
        });
        $('#expandSearch').on('show.bs.collapse', function () {
            var text = $("#expand-button").data("hide");
            $(".expand--status").html(text);
            $("#expand-button .icon").removeClass("icon--plus");
            $("#expand-button .icon").addClass("icon--min");
        });
    },
    expandButtonStateChange: function (state) { },
    featureBarCount: function () {
        $(".feature-bar--property").each(function () {
            var length = $(this).find(".feature__item").length;
            if (length <= 3) {
                $(this).addClass("has-" + length + "-items");
            }
        });
    },
    infiniteScroll: function (useButton = false) {
        $("#nextpage").hide();
        RP6.general.featureBarCount();

        var query = "";
        var infScroll = {

            bussy: false,    // Is there an ajax request in progress?
            done: false,     // Have all available publications been loaded?
            pageIndex: 1,    // Starting page.
            scrolled: false, // Check if user scrolled

            defaults: {                 // Default options for 'getPublications'
                ignoreBussy: false      // Ignore the bussy status
            },
            /**
             *  Load the next list of publications
             */
            getPublications: function (pubselector, loadPreviousPages, callback, options) {
                // Gather the options
                options = $.extend(options || {}, infScroll.defaults);

                // If we are bussy, don't do anything!
                // We can only handle one request at a time!
                if (!useButton) {
                    if (((!options.ignoreBussy && infScroll.bussy) || infScroll.done)) {
                        return false;
                    }
                }

                // Let everyone know we are bussy
                infScroll.bussy = true;

                // So show me the load more button
                $("#load-more").show();

                var page = location.href;
                page = RP6.general.removeURLParameter(page, "pageindex");

                // Add the pageIndex
                if (options.pageIndex || options.pageindex) {
                    page = RP6.general.UpdateQueryString("pageindex", options.pageIndex || options.pageindex, page);
                } else {
                    page = RP6.general.UpdateQueryString("pageindex", ++infScroll.pageIndex, page);
                }

                page = page + "&" + query;
                // Now, are there any more publications?
                $.get(page, function (response) {
                    // Trim spaces on start and end and parse to a jquery object
                    response = $($($.trim(response)).wrap("<div></div>").parent());

                    // If no publications were found, we are done loading publications
                    if (response.find(pubselector).length === 0) {
                        infScroll.done = true;
                    }

                    // We are no longer bussy!
                    infScroll.bussy = false;

                    // If a callback is set, execute it
                    if (!loadPreviousPages) {
                        if (!useButton) {
                            if (typeof callback != 'undefined') {
                                callback(response.find(pubselector));
                            }

                            // So remove load more button
                            if (!loadPreviousPages) {
                                $("#load-more").hide();
                            }
                        } else {
                            if (typeof callback != 'undefined') {
                                callback(response.find(pubselector));
                            }
                        }
                    } else {
                        if (typeof callback != 'undefined') {
                            callback(response.find(pubselector));
                        }

                        // So remove load more button
                        if (!loadPreviousPages) {
                            $("#load-more").hide();
                        }
                    }

                });

            },

            /**
             *  Check if an element is visible in the viewport
             *  Can be used for checking if a new page should be loaded
             */
            isInViewport: function (element) {

                // If no element is selected, don't bother looking for it
                if (!element) {
                    return false;
                }

                //Old
                // We need a bare HtmlDomElement
                //if (typeof jQuery === "function" && element instanceof jQuery) {
                //    element = element[0];
                //}

                //// Find out if the entire element is visible in the viewport
                //var rect = element.getBoundingClientRect();
                //return (
                //    rect.top >= 0 &&
                //    rect.left >= 0 &&
                //    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                //    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
                //);

                //New
                var elementTop = $(element).offset().top;
                var elementBottom = elementTop + $(element).outerHeight();

                var viewportTop = $(window).scrollTop();
                var viewportBottom = viewportTop + $(window).height();

                return elementBottom > viewportTop && elementTop < viewportBottom;
            },



            /**
             *  Recursively load a list of pages from pageIndex to 0
             */
            loadPagesRecursive: function (pubselector, pageIndex, loadPreviousPages) {
                // Create a deferred object
                var dfd = $.Deferred();

                // If we are on page 0, there is nothing more to load
                if (pageIndex === 0) {
                    return dfd.resolve().promise();
                }

                // Load the publications
                infScroll.getPublications(
                    pubselector,
                    loadPreviousPages,
                    function (objects) {

                        // Get the first publication on the page
                        var first = $(pubselector).first();

                        // Add the publications to the body
                        for (var i = 0; i < objects.length; i++) {
                            first.before(objects.eq(i));
                        }

                        // Load the next page
                        infScroll.loadPagesRecursive(pubselector, --pageIndex, loadPreviousPages)
                            .done(function () {
                                dfd.resolve();
                            });

                    },
                    {
                        ignoreBussy: true,
                        pageIndex: pageIndex
                    }
                );

                // Make a promise to notify the caller
                return dfd.promise();
            },


            /**
             *  Load all pages before the current page
             */
            loadPreviousPages: function (pubselector, callback) {
                // Get the current page index
                var pageIndex = location.search.replace(/.*?pageIndex=(\d+).*/i, '$1');
                if (pageIndex == location.search) {
                    pageIndex = 1;
                }

                // If we are on page index 1, there is nothing to load
                if (pageIndex == 1) {
                    if (typeof callback != 'undefined') {
                        callback(false);
                    }
                    return false;
                }

                // Set the page index, so we don't load publications twice
                infScroll.pageIndex = pageIndex;

                // Start loading pages
                infScroll.loadPagesRecursive(pubselector, --pageIndex, true)
                    .done(function () {
                        // When all is said and done, scroll to the last publication
                        if (location.hash.length > 0) {
                            // Get the publication id
                            var pubid = location.hash.substr(1);

                            // Find the publication with this id and scroll it into the viewport
                            if (!infScroll.scrolled) {
                                var el;
                                if ((el = $("a[href*='/" + pubid + "']")).length) {
                                    // Jump when the window is loaded
                                    $("html, body").animate({
                                        scrollTop: el.first().offset().top
                                    });
                                }
                            }

                            if (typeof callback != 'undefined') {
                                callback(true);
                            }
                        }
                    });
            }

        };

        if ($("#pubs .card--property").length) {
            //If infinite scroll with button => disable button when previous pages finished loading.
            //$(".btn--loadmorepubs").append("<div class='loader'></div>").addClass("searching");

            infScroll.loadPreviousPages("#pubs .card--property", function () {
                //if (useButton) {
                //    $(".btn--loadmorepubs .loader").remove();
                //    $(".btn--loadmorepubs").removeClass("searching");
                //}
            });

            // When user scrolls on return, stop the pub scroll animation
            if ($('#pubs .card--property[id]').length != 0) {
                $(window).on('mousewheel', function () {
                    infScroll.scrolled = true;
                });
            }

            // Start infinite scrolling
            if (!useButton) {
                $(window).on('scroll', function (e) {
                    if (!$(".card-deck").hasClass("card-deck--map")) {
                        // If we are on the second to last row, start loading more!
                        if (infScroll.isInViewport($("#pubs .card-deck:not(.card-deck--map) .card--property").eq(-2))) {
                            infScroll.getPublications('#pubs .card-deck:not(.card-deck--map) .card--property', false, function (objects) {
                                // We got the objects! add the new ones to the body
                                var count = 0;
                                for (var i = 0; i < objects.length; i++) {
                                    count = count + 1;
                                    objects.eq(i).hide().appendTo($('#pubs .card-deck')).fadeIn(1000);
                                }
                                RP6.general.featureBarCount();
                                RP6.general.initProjectLabels();
                            });
                        }
                    }
                });
            } else {
                if ($(".btn--loadmorepubs").data("multiplepages") != "False") {
                    $(".btn--loadmorepubs").on("click", function () {
                        $(".btn--loadmorepubs").append("<div class='loader'></div>").addClass("searching");
                      infScroll.getPublications('#pubs .card-deck:not(.card-deck--map) .card--property', false, function (objects) {
                            //Haal enkel de pub cards op, negeer de CTA cards.
                            var getPubCards = objects.filter(function(i, item) {
                              return !$(item).hasClass("card--subscribe");
                            });

                            //Controle doen op de gefilterde objects. Indien pagesize niet gelijk is aan getPubCards => de infinite scroll doen stoppen.
                            if ($(".btn--loadmorepubs").data("pagesize") != getPubCards.length) {
                                $(".btn--loadmorepubs").hide();
                            }

                            // We got the objects! add the new ones to the body
                            var count = 0;
                            for (var i = 0; i < objects.length; i++) {
                                count = count + 1;
                                objects.eq(i).hide().appendTo($('#pubs .card-deck')).fadeIn(1000);
                            }
                            RP6.general.featureBarCount();
                            RP6.general.initProjectLabels();
                            $(".btn--loadmorepubs .loader").remove();
                            $(".btn--loadmorepubs").removeClass("searching");
                        });
                    });
                } else {
                    $(".btn--loadmorepubs").hide();
                }

                $(".btn--view").on("click", function () {
                    if ($(".card-deck").hasClass("card-deck--map")) {
                        $(".btn--loadmorepubs").hide();
                    } else {
                        $(".btn--loadmorepubs").show();
                    }
                });
            }
        }
    },
    adaptiveNavigation: function () {
        function makeElem(cb) {
            var $navPrimary = $('.nav--primary');
            var $hellip = '<li class="nav-item js-item--more dropdown d-none" data-width="80"><a class="nav-link dropdown-toggle" href="#" id="dropdownMore" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">&hellip;</a><ul class="dropdown-menu dropdown-menu--nav" aria-labelledby="dropdownMore"></ul></li>';
            $navPrimary.append($hellip);
            if (cb) cb();
        }

        function calcWidth() {
            var navwidth = 0;
            var morewidth = $('.nav--primary .js-item--more').outerWidth(true);
            $('.nav--primary > li:not(.js-item--more)').each(function () {
                navwidth += $(this).outerWidth(true);
            });
            var availablespace = $('.navbar-collapse').outerWidth(true) - morewidth;
            if (navwidth > availablespace) {
                var lastItem = $('.nav--primary > li:not(.js-item--more)').last();
                lastItem.attr('data-width', lastItem.outerWidth(true));
                lastItem.prependTo($('.js-item--more > .dropdown-menu'));
                lastItem.children().addClass('dropdown-item');
                lastItem.children().removeClass('nav-link');
                calcWidth();
            } else {
                var firstMoreElement = $('.js-item--more li').first();
                if (navwidth + firstMoreElement.data('width') < availablespace) {
                    firstMoreElement.insertBefore($('.js-item--more'));
                    firstMoreElement.children().removeClass('dropdown-item');
                    firstMoreElement.children().not('.dropdown-menu').addClass('nav-link');
                }
            }
            if ($('.js-item--more li').length) {
                $('.js-item--more').removeClass('d-none');
            } else {
                $('.js-item--more').addClass('d-none');
            }
        }
        $(window).on('load', function () {
            if (window.innerWidth > 767) { makeElem(calcWidth); }
        });
        $(window).on('resize load', function () {
            if (window.innerWidth > 767) { calcWidth(); }
        });
    },
    initProjectLabels: function () {
        $(".offer__project--container").each(function (i) {
            //console.log($(this))
            RP6.general.showProjectLabelOnPub(+$(this).attr("data-estateid"),
                ($(this).attr("data-replacedetail") != undefined && $(this).attr("data-replacedetail") != "False" ? true : false)
            );
        })
    },
    showProjectLabelOnPub: function (estateID, replaceDetail = false) {
        if (estateID) {
            var getPathname = window.location.pathname;
            var protocol = window.location.protocol;

            if (getPathname.indexOf("responsive4") >= 0 || getPathname.indexOf("responsive5") >= 0 || getPathname.indexOf("responsive6") >= 0) {
                var getUrl = window.location.host + "/" + location.pathname.split('/')[1];
            } else {
                var getUrl = window.location.host;
            }

            var request = new XMLHttpRequest();
            var url = protocol + '//' + getUrl + '/query/GetParentProject?estateid=' + estateID;

            var getContainer = $(".offer__project--container." + estateID);

            if (getContainer.length != 0) {
                if (!getContainer.hasClass("projectified-done")) {
                    request.open("GET", url);
                    request.onreadystatechange = function () {
                        if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
                            var obj = JSON.parse(request.responseText),
                                id = obj.Id;

                            if (id != 0) {
                                var projectLabel = obj.ProjectName,
                                    projectUrl = obj.Url;

                                var a = getContainer.find(".project--name");
                                var span = getContainer.find(".project--title");

                                a.attr("href", protocol + "//" + getUrl + projectUrl);
                                span.text(projectLabel);

                                if (replaceDetail) {
                                    $(".card__image__link." + estateID).attr("href", protocol + "//" + getUrl + projectUrl);
                                    //getContainer.hide();
                                }

                            } else {
                                getContainer.remove();
                            }
                        }
                    }
                    request.send();
                    getContainer.addClass("projectified-done");
                }
            }
        }
    },
    removeURLParameter: function (url, parameter) {
        //prefer to use l.search if you have a location/link object
        var urlparts = url.split('?');
        if (urlparts.length >= 2) {

            var prefix = encodeURIComponent(parameter) + '=';
            var pars = urlparts[1].split(/[&;]/g);

            //reverse iteration as may be destructive
            for (var i = pars.length; i-- > 0;) {
                //idiom for string.startsWith
                if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                    pars.splice(i, 1);
                }
            }

            url = urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
            return url;
        } else {
            var prefix = encodeURIComponent(parameter) + '=';
            var pars = url.split(/[&;]/g);

            //reverse iteration as may be destructive
            for (var i = pars.length; i-- > 0;) {
                //idiom for string.startsWith
                if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                    pars.splice(i, 1);
                }
            }

            url = pars.join('&');
            return url;
        }
    },
    UpdateQueryString: function (key, value, url) {
        if (!url) url = window.location.href;
        var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
            hash;

        if (re.test(url)) {
            if (typeof value !== 'undefined' && value !== null)
                return url.replace(re, '$1' + key + "=" + value + '$2$3');
            else {
                hash = url.split('#');
                url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
                if (typeof hash[1] !== 'undefined' && hash[1] !== null)
                    url += '#' + hash[1];
                return url;
            }
        }
        else {
            if (typeof value !== 'undefined' && value !== null) {
                var separator = url.indexOf('?') !== -1 ? '&' : '?';
                hash = url.split('#');
                url = hash[0] + separator + key + '=' + value;
                if (typeof hash[1] !== 'undefined' && hash[1] !== null)
                    url += '#' + hash[1];
                return url;
            }
            else
                return url;
        }
    },
    submitForm: function (formClass) {
        $('.' + formClass + ' button[type=submit]').bind("click", function (e) {
            e.preventDefault();

            // 06/01/2022 NEW: extra JavaScript code voor reCAPTCHA V3. Als er geen #captchasitekey en #captchaaction aanwezig zijn, dan wordt de v3 niet gebruikt.
            if ($("#captchasitekey").length && $("#captchaaction").length) {
                grecaptcha.execute($("#captchasitekey").val(), { action: $("#captchaaction").val() }).then(function (token) {
                    $("#captcha").val(token);
                    $('.' + formClass).trigger("submit");
                });
            } else {
                $('.' + formClass).trigger("submit");
            }
        });
    },
    scrollHeader: function() {
      console.log('test');
      $(window).scroll(function () {
            if ($(this).scrollTop() >= 50) {
                $('header').addClass('small');
            } else {
                $('header').removeClass('small');
            }
        });
    }
};

RP6.search = {
    init: function () {
        //console.log('RP6.search.init');
        var alreadyLoaded = false;
        if ($("#cities") && $("#cities").data("subcity")) {
            var frm = $("#cities").parents(".form--search");
            RP6.search.reloadSubCities(frm, $("#cities").data("zipcodescities"));
            alreadyLoaded = true;
        }

        if ($("#cities") && !alreadyLoaded) {
            if ($("#cities").val() && $("#sorts").val() && $("#cities").val().length) {
                var frm = $("#cities").parents(".form--search");
                var field = $("#cities").attr("id");
                var value = $("#cities").val() == null ? "" : $("#cities").val().toString();
                RP6.search.reloadSorts(frm, RP6.search.createParam(field, value, true, $("#cities").data("zipcodescities")));
            }
            if ($("#cities").val() && $("#sorts").val() && $("#sorts").val().length) {
                var frm = $("#sorts").parents(".form--search");
                var field = $("#sorts").attr("id");
                var value = $("#sorts").val();
                RP6.search.reloadCities(frm, RP6.search.createParam(field, value));
            }
        }


        $("input.customSurface").autoNumeric('init', { aSep: ' ', aSign: ' m²', pSign: 's', mDec: '0' });
        $('input.customSurface').on('focus click', function () {
            var insertedValue = $(this).val().split(" m²")[0];
            if (insertedValue == "") {
                $(this)[0].setSelectionRange(0, 0);
            }
        });

        $("#sale, #rent, #transactiontype").on('change', function () {
            var value = ($(this).val() != null ? $(this).val().toString() : "sale");
            var frm = $(this).parents(".form--search");
            RP6.search.reloadFormAction(frm, value);

            if ($("#price-from", frm).length) {
                RP6.search.reloadPrice($("#price-from"), value);
            }

            if ($("#price-to", frm).length) {
                RP6.search.reloadPrice($("#price-to"), value);
            }

            if ($("#cities", frm).length) {
                RP6.search.reloadCities(frm);
                //is this true
            }

            if ($("#sorts", frm).length) {
                RP6.search.reloadSorts(frm);
            }
        });

        // On switch country
        $("#countries").on('change', function () {
            var frm = $(this).parents(".form--search");
            RP6.search.reloadCities(frm);
        });

        // City --> Filter Sorts
        $("#cities").on('change', function () {
            var frm = $(this).parents(".form--search");
            var field = $(this).attr("id");
            var value = $(this).val() == null ? "" : $(this).val().toString();

            RP6.search.reloadSorts(frm, RP6.search.createParam(field, value, true, $("#cities").data("zipcodescities")));
            if ($("#cities").data("zipcodescities")) {
                RP6.search.reloadDistance($(this));
            }
        });

        // Sorts --> Filter City
        $("#sorts").on('change', function () {
            var frm = $(this).parents(".form--search");
            var field = $(this).attr("id");
            var value = $(this).val() == null ? "" : $(this).val().toString();
            RP6.search.reloadCities(frm, RP6.search.createParam(field, value));
        });

        $("#mapbuffer").val($("#radius").val());
        $("#radius").on('change', function () {
            $("#mapbuffer").val($(this).val());
        });

        //If other options are in selectbox
        //if ($("#other-options").length != 0) {
        //    $('#other-options').on('changed.bs.select', function (e, clickedIndex, newValue, oldValue) {
        //        $(".otheroptions__hidden").find('input[type="checkbox"]').prop('checked', false);
        //        var selected = $(e.currentTarget).val();

        //        $(selected).each(function (index) {
        //            $(".otheroptions__hidden").find('input[name="' + this + '"]').prop('checked', true);
        //        });
        //    });

        //    var checked = $(".otheroptions__hidden").find('input[type="checkbox"]');
        //    var arrayChecked = new Array();
        //    $(checked).each(function (index) {
        //        if ($(this).is(":checked")) {
        //            arrayChecked.push($(this).attr("name"))
        //        }
        //    });
        //    $('#other-options').val(arrayChecked);
        //    $('#other-options').selectpicker('refresh');
        //}

        // On submit
        $(".form--search").submit(function () {

            if ($("#sorts").length && $("#sorts").val().length) {
                $("#sorts-hidden").val($("#sorts").val());
            }

            // on submit clear format on price and surface !
            $("input.customPrice, input.customSurface").each(function () {
                $(this).val($(this).autoNumeric("get"));
            });

            return true;
        });

    },
    reloadFormAction: function (field, value) {
        field.attr("action", field.data("action-" + value.toLowerCase()));
    },
    reloadPrice: function (field, value) {
        //change prices
        var prices = field.data(value.toLowerCase());
        var l_prices = prices && prices.split(",");

        $("option", field).each(function () {
            if ($(this).index() != 0 && $(this).index() != 1) {
                $(this).remove();
            }
        });

        // No minimum
        //if (field.data("min")) {
        //    field.append('<option>' + field.data("min") + '</option>');
        //}

        $.each(l_prices, function () {
            var option = $("<option />").val(this).text(parseFloat(this).toLocaleString("nl-BE", { style: "currency", currency: "EUR" }).replace(",00", ""));
            field.append(option);
        });

        // No maximum
        if (field.data("max")) {
            field.append('<option>' + field.data("max") + '</option>');
        }

        field.selectpicker("refresh");
    },
    reloadCities: function (field, extraQuery) {
        var currentVal = $("#cities").val();

        if ($("#cities").data("customcities") == true) {
            return;
        }

        // Subsites
        if ($("#cities").data("subcity") == true) {
            RP6.search.reloadSubCities(field, $("#cities").data("zipcodescities"));
            return;
        }

        var query = $(".reloadFields", field).serialize().replace("+", " ").replace(/€/g, "").replace(".", "").replace(/%E2%82%AC/g, "") + "&pagesize=0";
        if (extraQuery != null) {
            query = query + extraQuery;
        }

        var dataLowerCase = $("#cities").data("lowercasecities");
        var dataSubtext = $("#cities").data("show-subtext");
        var lowerCaseCities = dataLowerCase;

        // Get all cities
        Skarabee.SearchCities(Skarabee.ExtendQuery(query, ""), function (items) {
            items = Skarabee.Distinct(items, function (city) { return (lowerCaseCities ? city.Name.toLowerCase() : city.Name); });
            var selectOptions = $("#cities");
            var selectedCities = $("#cities").find("option:selected").val();
            selectOptions.empty();
            items.sort(function (a, b) {
                a = a.Name.toLowerCase();
                b = b.Name.toLowerCase();
                if (a < b) return -1;
                if (a > b) return 1;
                return 0;
            });
            $.each(items, function () {
                var option = $("<option />").val((lowerCaseCities ? this.Name.toLowerCase() : this.Name)).text((lowerCaseCities ? this.Name.toLowerCase() : this.Name));

                if (dataSubtext) {
                    option.attr("data-subtext", this.Zipcode);
                }

                if ($.inArray(this.Name, selectedCities) > -1) {
                    option.prop('selected', true);
                }

                selectOptions.append(option);
            });
        }).done(function () {
            $('#cities').selectpicker('val', currentVal);
            $('#cities').selectpicker('refresh');
        });
    },
    reloadSubCities: function (field, useZipcodesCities = false) {
        var currentVal = $("#cities").val();
        if ($("#cities").data("customcities") == true) {
            return;
        }

        // Query
        var query = $(".reloadFields", field).serialize().replace("+", " ").replace(/€/g, "").replace(".", "").replace(/%E2%82%AC/g, "") + "&pagesize=0&includeSubCities=true";

        // Lowercase
        var dataLowerCase = $("#cities").data("lowercasecities");
        var dataSubtext = $("#cities").data("show-subtext");
        var lowerCaseCities = dataLowerCase;

        //Enable zipcodesCities search
        var callDone = false,
            citiesWithNames;
        var enableZipcodesCities = (useZipcodesCities ? true : false);

        // Call
        Skarabee.SearchCities(Skarabee.ExtendQuery(query, ""), function (cities) {
            cities = Skarabee.Distinct(cities, function (city) { return city.Name.toLowerCase(); });

            if (RP6_VARS.rebindCity.length != 0) {
                $.each(RP6_VARS.rebindCity, function (i, cityItem) {
                    cities.filter(function (item) {
                        if (item.Zipcode == cityItem.Zipcode)
                            item.CityIds = [cityItem.CityId]
                    });
                });
                //console.log("Rebinding city...", cities);
            }

            var selectedCities = $("#cities > option:selected").map(function () {
                return this.value;
            }).get();

            var selectOptions = $("#cities");
            selectOptions.empty();

            citiesWithNames = $.map(cities, function (city) {
                citynames = [];
                citynamesZipcodes = [];
                onlyCitynames = [];
                for (var i in cities) {
                    for (var j in city.CityIds) {
                        for (var k in cities[i].CityIds)
                            if (cities[i].CityIds[k] == city.CityIds[j] && city.WithSubCities && !cities[i].WithSubCities) {
                                citynames.push(cities[i].Name);
                                citynames.push(cities[i].Zipcode);
                                onlyCitynames.push(cities[i].Name);
                                citynamesZipcodes.push(cities[i].Zipcode + "|" + cities[i].Name)
                            }
                    }
                }

                return {
                    Name: city.Name,
                    Zipcode: city.Zipcode,
                    subcityNames: onlyCitynames.join(','), // => Returns city1,city2,city3 //citynames.join(',') => Returns city1,zipcode1,city2,zipcode2
                    ZipCodeCity: city.Zipcode + "|" + city.Name,
                    subZipCodesCitys: citynamesZipcodes.join(',')
                };

            });

            citiesWithNames.sort(function (a, b) {
                a = a.Name.toLowerCase();
                b = b.Name.toLowerCase();
                if (a < b) return -1;
                if (a > b) return 1;
                return 0;
            });

            $.each(citiesWithNames, function (key, cityWithNames) {
                if (lowerCaseCities) {
                    cityWithNames.subZipCodesCitys = cityWithNames.subZipCodesCitys.toLowerCase();
                    cityWithNames.ZipCodeCity = cityWithNames.ZipCodeCity.toLowerCase();
                    cityWithNames.subcityNames = cityWithNames.subcityNames.toLowerCase();
                    cityWithNames.Name = cityWithNames.Name.toLowerCase();
                }
                var option = "";
                if (!enableZipcodesCities) {
                    option = $("<option />").val((cityWithNames.subcityNames != "" ? cityWithNames.subcityNames : cityWithNames.Name)).text(cityWithNames.Name);
                } else {
                    option = $("<option />").val((cityWithNames.subZipCodesCitys != "" ? cityWithNames.subZipCodesCitys : cityWithNames.ZipCodeCity)).text(cityWithNames.Name);
                }

                if (dataSubtext) {
                    option.attr("data-subtext", this.Zipcode);
                }

                if ($.inArray(cityWithNames.Name, selectedCities) > -1) {
                    option.prop('selected', true);
                }

                selectOptions.append(option);
            });

            //Include subcity values in the currentVal (ie. Kortrijk (+ deelgemeenten))
            if (currentVal.length > 1) {
                //Function to check if values from an array exists in another array
                let checker = (arr, target) => target.every(v => arr.includes(v));

                $.each(selectOptions.find("option"), function (i, key) {
                    var cityValue = $(key).val();
                    if (cityValue.indexOf(",") > -1) {
                        var valueArray = cityValue.split(",");
                        if (checker(currentVal, valueArray)) {
                            currentVal.push(cityValue);
                        }
                    }
                });
            }

            if (!$("#cities").data("useselect2")) {
                $('#cities').val(selectedCities);
                $('#cities').selectpicker("refresh");
            }
        }).done(function () {
            if (!$("#cities").data("useselect2")) {
                $('#cities').selectpicker('val', currentVal);
                $('#cities').selectpicker('refresh');
            } else {
                var select2 = $("#cities").select2({
                    theme: 'bootstrap4',
                    minimumInputLength: 3,
                    language: {
                        inputTooShort: function () {
                            return $("#cities").data("inputshort");
                        },
                        noResults: function () {
                            return $("#cities").data("noresults");
                        }
                    }
                });
                select2.val(currentVal).trigger("change");
            }
            callDone = true;
        });
    },
    reloadSorts: function (field, extraQuery) {
        var currentVal = $("#sorts").val();

        var query = $(".reloadFields", field).serialize().replace("+", " ").replace(/€/g, "").replace(".", "").replace(/%E2%82%AC/g, "") + "&pagesize=0";
        if (extraQuery != null) {
            query = query + extraQuery;
        }

        query = query.replace(/flowstatus=.*?&/, "", query);

        Skarabee.SearchEstateCategories(Skarabee.ExtendQuery(query, ""), function (categories) {
            //get selected types
            var selectedSorts =
                $("#sorts").find("option:selected").val();

            var selectOptions = $("#sorts");
            selectOptions.empty();

            //selectOptions.append('<option disabled>' + $("#sorts").data("placeholder") + '</option>');

            $.each(categories, function () {
                var category = this.Value;

                var selectOptionsGroup = $("<optgroup />").attr("label", category);

                Skarabee.SearchEstateSorts(Skarabee.ExtendQuery(query, "&categories=" + this.Key), function (sorts) {
                    sorts.sort(function (a, b) {
                        a = a.Key.toLowerCase();
                        b = b.Key.toLowerCase();
                        if (a < b) //sort string ascending
                            return -1;
                        if (a > b)
                            return 1;
                        return 0;
                    });

                    $.each(sorts, function (index) {
                        var option = $("<option />").val(this.Key).text(this.Value);

                        if ($.inArray(this.Key, selectedSorts) > -1) {
                            option.prop('selected', true);
                        }

                        selectOptionsGroup.append(option);
                    });
                }).done(function () {
                    $('#sorts').selectpicker('val', currentVal);
                    $("#sorts").selectpicker("refresh");
                });

                selectOptions.append(selectOptionsGroup);
            });
        });
    },
    reloadDistance: function (el) {
        var selected = $.unique(el.val());
        $("#zipcodescities").val(selected);
        //console.log(selected); 

        if (selected.length == 1 && selected[0].indexOf(",") == -1) {
            $("#sortfield_hidden").val($("#sortfield_hidden").data("distance"));
            $("#sortdirection_hidden").val($("#sortdirection_hidden").data("distance"));
        } else {
            $("#sortfield_hidden").val($("#sortfield_hidden").data("originalvalue"));
            $("#sortdirection_hidden").val($("#sortdirection_hidden").data("originalvalue"));
        }
    },
    createParam: function (field, value, isCity = false, useZipcodesCities = false) {
        if (isCity && useZipcodesCities && value != "") {
            var cities = "";
            var valueSplit = value.split(",");
            if (valueSplit.length != 0) {
                $.each(valueSplit, function (i, e) {
                    cities += e.split("|")[1] + (i != valueSplit.length - 1 ? "," : "");
                });
                if (cities != "") {
                    return "&" + field + "=" + cities;
                }
            }
        }
        return "&" + field + "=" + value;
    }
};

RP6.detail = {
    init: function () {
        if ($(".slideshow--detail .images-container .detail-image").length > 1) {
            const detailSlideshowProps = RP6.general.getSpecificVars("DETAIL");
            var $carousel = $(".slideshow--detail .images-container");
            RP6.slideshow.init(".slideshow--detail .images-container", detailSlideshowProps);

            $carousel.magnificPopup({
                type: 'image',
                delegate: '.slick-slide:not(.slick-cloned) .detail-image',
                closeOnContentClick: false,
                tLoading: 'Loading...',
                mainClass: 'mfp-zoom-in mfp-img-mobile',
                image: {
                    verticalFit: true
                },
                gallery: {
                    enabled: true,
                    navigateByImgClick: true,
                    tCounter: '<span class="mfp-counter">%curr% / %total%</span>', // markup of counte
                    preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
                },
                zoom: {
                    enabled: true,
                    duration: 200
                },
                removalDelay: 300,
                callbacks: {
                    open: function () {
                        // Swipe support in MagnificPopup (uses Touch.Swipe lib)
                        $("body").swipe({
                            swipeLeft: function (event, direction, distance, duration, fingerCount) {
                                $(".mfp-arrow-right").magnificPopup("next");
                            },
                            swipeRight: function () {
                                $(".mfp-arrow-left").magnificPopup("prev");
                            },
                            threshold: 50
                        });

                        //overwrite default prev + next function. Add timeout for css3 crossfade animation
                        $.magnificPopup.instance.next = function () {
                            var self = this;
                            self.wrap.removeClass('mfp-image-loaded');
                            setTimeout(function () { $.magnificPopup.proto.next.call(self); }, 120);
                        };
                        $.magnificPopup.instance.prev = function () {
                            var self = this;
                            self.wrap.removeClass('mfp-image-loaded');
                            setTimeout(function () { $.magnificPopup.proto.prev.call(self); }, 120);
                        };
                        var current = $carousel.slick('slickCurrentSlide');
                        $carousel.magnificPopup('goTo', current);
                    },
                    imageLoadComplete: function () {
                        var self = this;
                        setTimeout(function () { self.wrap.addClass('mfp-image-loaded'); }, 16);
                    },
                    beforeClose: function () {
                        $("body").swipe("destroy");
                        $carousel.slick('slickGoTo', parseInt(this.index));
                    }
                }
            });
            //Clicked on clone = open original
            $(".images-container .slick-cloned .detail-image").click(function (e) {
                e.preventDefault();
                $(".slick-slide:not(.slick-cloned) .detail-image[data-img-ref=\"" + $(this).data("img-ref") + "\"]").trigger("click");
            });
        }
    },
    mediaMagnificPopup: function (element, overwriteOptions) {
        var options = {
            items: [],
            type: "iframe",
            gallery: true
        };

        $.extend(true, options, overwriteOptions);

        $(element).magnificPopup({
            items: options.items,
            gallery: {
                enabled: options.gallery
            },
            type: options.type,
            callbacks: {
                beforeOpen: function () {
                    $('body').addClass('mfp--active');
                },
                beforeClose: function () {
                    $('body').removeClass('mfp--active');
                }
            }
        });
    },
    viewer360MagnificPopup: function(element, overwriteOptions) {
        var options = {
            items: [],
            iframe: {},
            type: "iframe",
            gallery: true,
            callbacks: {}
        };

        $.extend(true, options, overwriteOptions);

        $(element).magnificPopup({
            items: options.items,
            iframe: options.iframe,
            gallery: {
                enabled: options.gallery
            },
            type: options.type,
            callbacks: options.callbacks
        });
    },
    viewer360CreateMenuItems: function(description, count, maxMenuItems) {
        if (count < maxMenuItems) {
            $(".mfp-header .mfp-header--menu .mfp-header--menu__nav").append("<span class='btn" + (count == 0 ? " active" : "") + "' data-id=" + count + ">" + description + "</span>");
        } else {
            $(".mfp-header .mfp-header--menu .dropdown-menu").append('<a class="dropdown-item" href="#" data-id=' + count + '>' + description + '</a>');
        }
        $(".mfp-header .mfp-header--mobile .dropdown-menu").append('<a class="dropdown-item" href="#" data-id=' + count + '>' + description + '</a>');
        return count + 1;
    },
    viewer360SetActiveItem: function(parentElement, el, isMobile = false) {
        $(el).on("click", function () {
            $(this).removeClass("active");
            $(".mfp-header--menu span, .dropdown-toggle, .dropdown-item").removeClass("active");

            if ($(this).is("span")) {
                $(this).addClass("active");
            } else if ($(this).hasClass("dropdown-item")) {
                $(".dropdown-toggle").addClass("active");
                $(this).addClass("active")
            }

            if (isMobile)
                $(".mfp-header--mobile .dropdown-toggle").text($(this).text());

            $(parentElement).magnificPopup('goTo', $(this).data("id"));
        });
    },
    contactMagnificPopup: function (element) {
        $(element).magnificPopup({
            type: 'inline',
            midClick: true,
            mainClass: "mfp--overflow",
            callbacks: {
                beforeOpen: function () {
                    $('body').addClass('mfp--active');
                },
                open: function () {
                    if (element == ".mailafriend--modal") {
                        RP6.detail.resizeIFrame("#mailafriend--iframe");
                    } else if (element == ".btn--visit") {
                        RP6.detail.resizeIFrame("#visitForm--iframe");
                    } else if (element == ".download--modal") {
                        RP6.detail.resizeIFrame("#download--iframe");
                    } else if (element == ".btn--bid") {
                        RP6.detail.resizeIFrame("#bid--iframe");
                    }
                    //var iframeName = element.replace(/\.|--modal/g, "");
                    //RP6.detail.resizeIFrame("#" + iframeName + "--iframe");
                },
                beforeClose: function () {
                    $('body').removeClass('mfp--active');
                },
                afterClose: function () {
                    var item = localStorage.getItem("submit");
                    if (item != null) {
                        localStorage.removeItem("submit");
                    }
                }
            }
        });
    },
    printDetail: function (element, page, title) {
        $(element).click(function (e) {
            e.preventDefault();
            window.open(page, title, "width=750, height=700, scrollbars=yes");
        });
    },
    splitTableChar: function () {
        var navigationTable = document.querySelector(".nav-tabs--detail-table");
        if (!navigationTable) return;

        var style = getComputedStyle(navigationTable);
        var mediaQuery = window.matchMedia("(max-width: 767px)");

        if (!mediaQuery.matches) {
            if (style.flexBasis !== "25%") {
                var $t = $('.tab-content .table--detail:not(#legalinformation)').find('table');

                $($t).each(function (index) {
                    var max = Math.ceil(($(this).find('tr').length / 2));
                    var l = $('tr', $(this)).length;

                    while (l > max) {
                        // extract trs with index larger than max and add them to a new table
                        var $trs = $('tr', $(this)).filter(function () { return $(this).index() < max; });
                        $('<table/>').append($trs).insertBefore($(this));
                        l -= max;
                    }
                });
            }
        }
    },
    fuseLegalTable: function () {
        if ($(".wrap--tabs #legalinformation").length) {
            $('<table class="table table-responsive tblLegalComplete"><tbody></tbody></table>').appendTo('.wrap--tabs #legalinformation .tables--container');
            $(".wrap--tabs #legalinformation .tables--container .tblLegal").each(function () {
                var tableRow = $(this).find("tr");
                $(".tblLegalComplete tbody").append(tableRow);
            });
            $('.wrap--tabs #legalinformation .tables--container .tblLegal').remove();
        }
    },
    resizeIFrame: function (element) {
        $(element).bind('load', function () {
            $(element).height($(element).contents().height());
        });
    },
    formSubmitted: function (element) {
        var item = localStorage.getItem("submit");
        if (item == null) {
            $(element).submit(function (event) {
                localStorage.setItem("submit", true);
            });
        } else {
            setTimeout(function () { $(".btn--contact").trigger("click"); }, 100);
        }
    },
    initSunMap: function (mymap) {
        var showShadows = false;
        $(".sunmap").click(function () {
            showShadows = !showShadows;
            if (showShadows) {
                $(".sunmap").addClass("active");
                $(".time-control").removeClass("hidden");
                RP6.detail.loadShadows(mymap);
            } else {
                $(".sunmap").removeClass("active");
                $(".time-control").addClass("hidden");
                osmb.remove();
            }
        });
    },
    loadShadows: function (mymap) {
        osmb = new OSMBuildings(mymap).load();
        var now,
            date, time,
            timeRange, dateRange,
            timeRangeLabel, dateRangeLabel;

        function changeDate() {
            var Y = now.getFullYear(),
                M = now.getMonth(),
                D = now.getDate(),
                h = now.getHours(),
                m = 0;

            timeRangeLabel.innerText = pad(h) + ':' + pad(m);
            dateRangeLabel.innerText = pad(D) + '-' + pad(M + 1) + '-' + Y;

            osmb.date(new Date(Y, M, D, h, m));
        }

        function onTimeChange() {
            now.setHours(this.value);
            now.setMinutes(0);
            changeDate();
        }

        function onDateChange() {
            now.setMonth(0);
            now.setDate(this.value);
            changeDate();
        }

        function pad(v) {
            return (v < 10 ? '0' : '') + v;
        }

        timeRange = document.getElementById('time');
        dateRange = document.getElementById('date');
        timeRangeLabel = document.querySelector('*[for=time]');
        dateRangeLabel = document.querySelector('*[for=date]');

        now = new Date;
        changeDate();

        // init with day of year
        var Jan1 = new Date(now.getFullYear(), 0, 1);
        dateRange.value = Math.ceil((now - Jan1) / 86400000);

        timeRange.value = now.getHours();

        timeRange.addEventListener('change', onTimeChange);
        dateRange.addEventListener('change', onDateChange);
        timeRange.addEventListener('input', onTimeChange);
        dateRange.addEventListener('input', onDateChange);
    },
    hasVisitReservation: function () {
        const reservation = $("#reservation");
        reservation[0].addEventListener('initialised', (event) => {
            //console.log(event);
            if (event.detail.success) {
                var dates = event.detail.data;

                var language = reservation.attr("language");
                const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

                var allUnavailable = true;
                var availableDates = "";
                $.each(dates, function (i, e) {
                    var d = new Date(e.dateFrom);
                    availableDates += d.toLocaleDateString(language, options) + (i != (dates.length - 1) ? " / " : "");

                    $.each(e.slots, function (ii, ee) {
                        if (ee.available) {
                            allUnavailable = false;
                        }
                    });
                });

                $(".reservation--loading").addClass("hide");
                $(".jumbotron--banner__reservation .jumbotron__subtitle").text(availableDates);
                $(".btn--visit").removeClass("btn--visit__component--hidden");

                if (allUnavailable) {
                    $(".show__reservation--full").addClass("show");
                } else {
                    $(".new__reservation--title").addClass("all--available");
                }
            }
        });
    },
    showInvestr: function (el, url) {
      console.log("test");
      $.ajax({
          url: url,
          type: "GET",
          dataType: "jsonp",
          cors: true,
          secure: true,
          headers: {
              'Access-Control-Allow-Origin': '*',
          },
          statusCode: {
              200: function () {
                  //console.log("Investr: status code 200");
                  $(el).show();
              }
          },
      });
    }
};

$bookedDates = [];
$ownerDates = [];
$optionDates = [];
RP6.holidayrent = {
    initSearch: function (plchldrPeriod) {

        // check already selected fields
        RP6.holidayrent.checkSelectedDates();
        RP6.holidayrent.checkSelectedFieldByParam($("#capacity-from"), 'capacity-from');
        RP6.holidayrent.checkSelectedFieldByParam($("#marketingtypes"), 'marketingtypes');

        RP6.holidayrent.changeDates(plchldrPeriod);

    },
    initDetail: function (currentYear, currentMonth, hasPeriods) {
       /* RP6.holidayrent.triggerPeriodChange(hasPeriods);*/
        RP6.holidayrent.setIFrameOnDateClick();

        RP6.holidayrent.initDatepickerDetail(currentYear, currentMonth); 
        RP6.holidayrent.checkSelectedDates(); 
    },
    triggerPeriodChange: function (hasPeriods) {
        if (hasPeriods) {
            if ($('#period').length) {
                $('#period').on("change", (function () {
                    $('.periodPrice').hide();
                    $('.' + $(this).val() + 'period').show();
                }));
                $('#period').trigger('change');
            }
        }
    },
    changeDates: function (plchldr) {
        plchldr = plchldr.replace('&#228;', 'ä');
        var selectPeriode = $("#period");
        selectPeriode.change(function () {
            $("#date").val(plchldr);
            if (selectPeriode.val() != "" && selectPeriode.val() != null) {
                $("#date").attr("placeholder", plchldr).removeAttr("disabled");
                $("#datefrom,#dateto").val("");
                $availableDates = [];
                Skarabee.GetRentPeriodsForType(selectPeriode.val(), function (periodtypes) {
                    $.each(periodtypes, function () {
                        $availableDates.push([this.DateFromString, this.DateToString, this.Id]);
                    });
                });
            }
        });

        $("#date").datepicker({
            dateFormat: 'dd M yy',
            beforeShowDay: RP6.holidayrent.checkAvailableDates, //Color available dates depending on selected period           
            onSelect: RP6.holidayrent.checkFromToDate, //After startdate is selected, set Dates in hidden fields
            minDate: 0,
            firstDay: 1,
            maxDate: "+13m"
        });
    },
    setIFrameOnDateClick: function () {
        if ($('.link-reserve').length) {
            $('.link-reserve').click(function (e) {
                var source = $(this).data('source');
                $.magnificPopup.open({
                    items: {
                        src: '#holidayrent--modal'
                    },
                    type: 'inline',
                    midClick: true,
                    mainClass: "mfp--overflow",
                    callbacks: {
                        beforeOpen: function () {
                            $('body').addClass('mfp--active');
                            $('html').css('overflow', 'hidden');
                        },
                        open: function () {
                            var $iframe = $('#holidayrent-reserve--iframe');
                            $iframe.attr('src', source);
                            RP6.detail.resizeIFrame($iframe);
                        },
                        beforeClose: function () {
                            $('body').removeClass('mfp--active');
                            $('html').css('overflow', 'auto');
                        }
                    }
                });
            });
        };
    },
    initDatepickerDetail: function (currentYear, currentMonth, numberOfMonths) {
        $("#datepicker").datepicker({
            numberOfMonths: numberOfMonths,
            firstDay: 1,
            gotoCurrent: false,
            dateFormat: "dd-mm-yy",
            defaultDate: 0,
            //minDate: minDate,
            minDate: 0,
            showButtonPanel: false,
            beforeShowDay: RP6.holidayrent.checkDates,
            onChangeMonthYear: RP6.holidayrent.showMonths, // show/hide reserve links beneath datepicker
            maxDate: "+13m"
        });

        // We're going to "debounce" the resize, to prevent the datePicker
        // from being called a thousand times.  This will help performance
        // and ensure the datepicker change is only called once (ideally)
        // when the resize is OVER
        var debounce;
        // Your window resize function
        $(window).resize(function () {
            // Clear the last timeout we set up.
            clearTimeout(debounce);
            // Your if statement
            if ($(window).width() > 1024) {
                // Assign the debounce to a small timeout to "wait" until resize is over
                debounce = setTimeout(function () {
                    // Here we're calling with the number of months you want - 1
                    debounceDatepicker(3);
                }, 250);
                // Presumably you want it to go BACK to 2 or 3 months if big enough
                // So set up an "else" condition
            } else if ($(window).width() > 768) {
                // Assign the debounce to a small timeout to "wait" until resize is over
                debounce = setTimeout(function () {
                    // Here we're calling with the number of months you want - 1
                    debounceDatepicker(2);
                }, 250);
                // Presumably you want it to go BACK to 2 or 3 months if big enough
                // So set up an "else" condition
            } else {
                debounce = setTimeout(function () {
                    // Here we're calling with the number of months you want - 3?
                    debounceDatepicker(1)
                }, 250);
            }
            // To be sure it's the right size on load, chain a "trigger" to the
            // window resize to cause the above code to run onload
        }).trigger('resize');

        // our function we call to resize the datepicker
        function debounceDatepicker(no) {
            $("#datepicker").datepicker("option", "numberOfMonths", no);
        }

        RP6.holidayrent.showMonths(currentYear, currentMonth);
    },
    checkDates: function (mydate) {
        //initiate available dates in calendar of detailpage
        var $return = false;
        var $returnclass = "unavailable";
        $checkdate = $.datepicker.formatDate('dd-mm-yy', mydate);

        if (typeof halfdays !== 'undefined') {
            if (!halfdays) {
                for (var i = 0; i < $availableDates.length; i++) {
                    if ($availableDates[i] == $checkdate) {
                        $return = true;
                        $returnclass = "available";
                    }
                }
            } else {
                for (var i = 0; i < $availableDates.length; i++) {
                    var availableSplit = $availableDates[i].split(",");

                    var date = availableSplit[0];
                    var availAM = availableSplit[1];
                    var availPM = availableSplit[2];

                    if (date == $checkdate) {
                        if (availAM && availPM) {
                            $return = true;
                            $returnclass = "available";
                        }
                        if (availAM == "True" && availPM == "False") {
                            $return = true;
                            $returnclass = "availableAM";
                        }
                        if (availAM == "False" && availPM == "True") {
                            $return = true;
                            $returnclass = "availablePM";
                        }
                    }
                }
            }

        } else {
            for (var i = 0; i < $availableDates.length; i++) {
                if ($availableDates[i] == $checkdate) {
                    $return = true;
                    $returnclass = "available";
                }
            }
        }

        for (var i = 0; i < $bookedDates.length; i++) {
            if ($bookedDates[i] == $checkdate) {
                $return = true;
                $returnclass = "booked";
            }
        }
        for (var i = 0; i < $ownerDates.length; i++) {
            if ($ownerDates[i] == $checkdate) {
                $return = true;
                $returnclass = "owner";
            }
        }
        for (var i = 0; i < $optionDates.length; i++) {
            if ($optionDates[i] == $checkdate) {
                $return = true;
                $returnclass = "hroption";
            }
        }
        return [$return, $returnclass];

    },
    showMonths: function (year, month) {
        if ($(window).width() < 768) {
            $('.month').each(function () {
                $(this).hide();
            });
            $('.month.m' + month + 'y' + year).show();
        } else if ($(window).width() < 1024) {
            $('.month').each(function () {
                $(this).hide().removeClass('last');
            });
            if (month == 12) {
                var month2 = 1;
                var year2 = year + 1;
            } else {
                var month2 = month + 1;
                var year2 = year;
            }
            $('.month.m' + month + 'y' + year).show();
            $('.month.m' + month2 + 'y' + year2).show().addClass('last');
        } else {
            $('.month').each(function () {
                $(this).hide().removeClass('last');
            });
            if (month == 12) {
                var month2 = 1;
                var year2 = year + 1;
            } else {
                var month2 = month + 1;
                var year2 = year;
            }
            if (month > 10) {
                var month3 = (month + 2) - 12;
                var year3 = year + 1;
            } else {
                var month3 = month + 2;
                var year3 = year;
            }
            $('.month.m' + month + 'y' + year).show();
            $('.month.m' + month2 + 'y' + year2).show();
            $('.month.m' + month3 + 'y' + year3).show().addClass('last');
        }
    },
    checkAvailableDates: function (mydate) {
        //add classes to availables startdates in datepicker
        var $return = false;
        var $returnclass = "unavailable";
        $checkdate = $.datepicker.formatDate('dd-mm-yy', mydate);
        if ($availableDates != null) {
            for (var i = 0; i < $availableDates.length; i++) {
                if ($availableDates[i][0] == $checkdate) {
                    $return = true;
                    $returnclass = "available";
                }
            }
        }
        return [$return, $returnclass];
    },
    checkFromToDate: function (fromDate) {
        //fill in hidden fields 
        $checkToDate = $.datepicker.parseDate('dd M yy', fromDate);
        $checkToDateP = $.datepicker.formatDate('dd-mm-yy', $checkToDate);
        for (var i = 0; i < $availableDates.length; i++) {
            if ($availableDates[i][0] == $checkToDateP) {
                $('#datefrom').val($availableDates[i][0]);
                $('#dateto').val($availableDates[i][1]);
                $('#periodid').val($availableDates[i][2]);
            }
        }
        $toDate = $.datepicker.parseDate('dd-mm-yy', $('#dateto').val());
        $toDateP = $.datepicker.formatDate('dd M yy', $toDate);
        //fill in startDate and toDate in datepicker
        $('#date').val($('#date').val() + " - " + $toDateP);
    },
    checkSelectedDates: function () {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);

        //put option selected when period is already choosen
        if (urlParams.has("period")) {
            $('#period option[value="' + urlParams.get("period") + '"]').attr("selected", "selected");
            $("#period").trigger("change");
        }

        //change startdates in datepicker depending on selected period
        if (urlParams.has("datefrom")) {
            $thisDate = $.datepicker.parseDate('dd-mm-yy', urlParams.get("datefrom"));
            $thisDate = $.datepicker.formatDate('dd M yy', $thisDate);
            //$("#date").datepicker("setDate", $thisDate);
            $('#date').val($thisDate);
        }
        if (urlParams.has("dateto")) {
            $thisDate = $.datepicker.parseDate('dd-mm-yy', urlParams.get("dateto"));
            $thisDate = $.datepicker.formatDate('dd M yy', $thisDate);
            $('#date').val($('#date').val() + " - " + $thisDate);
            $("#date").removeAttr("disabled");
        }
    },
    checkSelectedFieldByParam: function (field, param) {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        var arrParam = urlParams.get(param);
        if (arrParam != "" && arrParam != null) {
            field.selectpicker('val', arrParam);
        }
    },
    checkSelectedDatesReserve: function () {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        //change startdates in datepicker depending on selected period
        if (urlParams.has("datefrom")) {
            $thisDate = $.datepicker.parseDate('dd-mm-yy', urlParams.get("datefrom"));
            $thisDate = $.datepicker.formatDate('dd M yy', $thisDate);
            $('#date').val($thisDate);
        }
        if (urlParams.has("dateto")) {
            $thisDate = $.datepicker.parseDate('dd-mm-yy', urlParams.get("dateto"));
            $thisDate = $.datepicker.formatDate('dd M yy', $thisDate);
            $('#date').val($('#date').val() + " - " + $thisDate);
        }
    },
    getUrlParameter: function (field) {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        urlParams.get(field);
    }
};

RP6.subscribe = {

    init: function () {
        const isFormLight = document.querySelector('.subscribe-form--light') !== null;
        RP6.subscribe.setSteps();
        setTimeout(() => { RP6.subscribe.setStepHeight(); }, 100);
        RP6.subscribe.generateFormData();

        window.addEventListener("resize", function () {
            RP6.subscribe.setStepHeight();
        });

        let isAlreadyShown = false;
        $('[name="MatchCriteria.TransactionType"]').on("change", function () {
            if (isAlreadyShown) return;

            if (isFormLight) {
                $(this).closest('.sub-step').find('.step-rule').removeClass("text-danger");
                $(this).closest('.sub-step').prop("isValid", true);

                $('body, html').animate({
                    scrollTop: $(".sub-step.invisible").offset().top - 100
                }, 500);

                $('.sub-step.invisible').removeClass('invisible');
            } else {
                $(this).closest('.subscribe-form__content').find('.step-rule').removeClass("text-danger");
            }

            isAlreadyShown = true;
        });
    },
    setSteps: function () {
        NodeList.prototype.find = Array.prototype.find;
        NodeList.prototype.filter = Array.prototype.filter;

        //Initialize the steps library
        $('#subscribe-form__wrap').steps({
            stepSelector: ".step__btn",
            contentSelector: ".subscribe-form__content",
            errorClass: "step-error",

            onChange: function (current, next) {
                if (current !== next) {
                    const isValid = isStepValid(current);

                    if (isValid) {
                        if (current !== 5 && window.innerWidth < 600) {
                            animateSteps(current);
                        }

                        setHeight(current);
                    }

                    highlightStepError(current, isValid);

                    return isValid;
                }

                return true;
            },

            onFinish: function () {
                const $submit = document.querySelector('.btn-subscribe-submit');
                if ($submit) {
                  if ($("#captchasitekey").length && $("#captchaaction").length) {
                    grecaptcha.execute($("#captchasitekey").val(), { action: $("#captchaaction").val() }).then(function (token) {
                      $("#captcha").val(token);
                      $submit.click();
                    });
                  } else {
                    $submit.click();
                  }
                }
                RP6.subscribe.setStepHeight();
            }
        });

        //Animate step buttons (1 2 3...)
        const animateSteps = function (index) {
            if (window.innerWidth > 600 || index === 5 || document.querySelector('.subscribe-form--light')) return;
            //if (index === 4 && isStep5Removed) return;

            const $wrapper = document.querySelector('.step-btns__moving-wrapper');
            //each step is 30vw (minus 1 to start the animation from the 2nd step)
            $wrapper && ($wrapper.style.transform = "translateX(-" + (index - 1) * 30 + "vw)");
        };

        const highlightStepError = function (index, valid) {
            const isFormLight = document.querySelector('.subscribe-form--light') !== null;
            const $step = document.querySelector(`.subscribe-form__content[data-step-index="${index}"]`);

            if (isFormLight) {
                const $subSteps = $step.querySelectorAll('.sub-step');
                $subSteps.filter(function (subStep) {
                    const $rule = subStep.querySelector('.step-rule');
                    if (!$rule) return;

                    if (!subStep.isValid && !subStep.classList.contains("invisible")) {
                        $($rule).addClass('text-danger animation--wobble');
                        setTimeout(function () {
                            $($rule).removeClass("animation--wobble");
                        }, 900);
                    } else {
                        $($rule).removeClass('text-danger');
                    }
                });
            } else {
                const $rule = $step.querySelector(`.step-rule`);
                if (!valid) {
                    $($rule).addClass('text-danger animation--wobble');
                    setTimeout(function () {
                        $($rule).removeClass("animation--wobble");
                    }, 900);
                } else {
                    $($rule).removeClass('text-danger');
                }
            }
        };

        const setHeight = function (index) {
            const $step = document.querySelector(`.subscribe-form__content[data-step-index="${index}"]`);

            $('body,html').animate({
                scrollTop: $(".subscribe-form__content[data-step-index=" + index + "]").offset().top - 180
            }, 500);

            $step && $step.addEventListener("transitionend", () => {
                RP6.subscribe.setStepHeight();
            });
        };

        //Checking if step is valid based on the given index
        const isStepValid = function (index) {
            const $step = document.querySelector(`.subscribe-form__content[data-step-index="${index}"]`);
            if (!$step) return;


            const validate = function () {
                const stepRule = $step.dataset.rule;
                const $inputs = $step.querySelectorAll("input");
                const $select = $step.querySelector('select');

                // Get the required fields based on the required message
                const $requiredFields = $step.querySelectorAll(`.required-subscribe-field`);
                const validFields = [];

                // If there are required fields
                if ($requiredFields.length > 0) {
                    $requiredFields.forEach(field => {
                        // Get the name="" of the input
                        const fieldName = field.dataset.fieldName;
                        // Get the type of the field (select || input)
                        const fieldType = field.dataset.fieldType ? field.dataset.fieldType.toLowerCase() : false;
                        const $validationMessage = field.querySelector(".validation-message");

                        if (fieldName && fieldType && $validationMessage) {
                            // Get the form input
                            const $field = $step.querySelector(`${fieldType}[name="${fieldName}"]`);

                            // If field has value, add it to the list of good boys
                            if ($field && $field.value && $field.value.trim() !== "" && $field.value.trim() !== "0") {
                                validFields.push(field);
                                $validationMessage.classList.add('field-validation-valid');
                                $validationMessage.classList.remove('field-validation-error');
                            } else {
                                $validationMessage.classList.add('field-validation-error');
                                $validationMessage.classList.remove('field-validation-valid');
                            }
                        }
                    });

                    // Only return false if any of the required fields is false, otherwise continue with the default validation
                    if ($requiredFields.length !== validFields.length) return false;
                }


                //When adding new validation rules, always return a boolean!
                switch (stepRule) {
                    //Minimum one option or radio is selected
                    case "minimum-one":
                        return $inputs.find(el => el.checked);

                    //A selectbox is required
                    case "required-select":
                        if ($select) {
                            return $select.selectedIndex !== 0;
                        }

                    //Fill in the previous criteria (in the same step) first
                    case "fill-to-proceed":
                        const $subSteps = $step.querySelectorAll('.sub-step');
                        const $validSubSteps = $subSteps.filter(subStep => subStep.isValid);

                        return $subSteps.length === $validSubSteps.length;

                    case "required-field":
                        const $field = document.getElementById($step.dataset.requiredField);
                        if (!$field) break;

                        const validator = $("#frm_subscribe").validate();
                        return validator.element($field);

                    case "optional":
                        return true;

                    default:
                        return true;
                }
            };

            return validate();
        };
    },
    //Set the step height
    setStepHeight: function () {
        const $container = document.querySelector(".step-content");
        const $activeStep = document.querySelector('.subscribe-form__content.active');
        //const isFormDefault = document.querySelector('.subscribe-form--default') !== null;

        let height = 0;

        if (!$container || !$activeStep) return;

        height = $activeStep.getBoundingClientRect().height + 10;

        //const activeStepHeight = $activeStep.getBoundingClientRect().height;

        //if (!isFormDefault) {
        //} else {
        //    const $step5 = document.querySelector('.subscribe-form__content[data-step-index="4"]');
        //    if (!$step5) return;

        //    height = activeStepHeight > $step5.getBoundingClientRect().height ? activeStepHeight + 10 : $step5.getBoundingClientRect().height + 10;
        //}

        $container.style.height = height + "px";
    },
    generateFormData: function () {
        const $types = document.querySelector("select[name=\"MatchCriteria.Sorts\"]");
        const $subTypes = document.querySelector(".subtypes__content");
        const $characterisations = document.querySelector(".chars__content");
        const $subtypeSelect = document.querySelector("#subtypeSelect");
        const $charSelect = document.querySelector("#charSelect");
        const $subtypesTitle = document.querySelector('.types-wrapper--subtypes .types-title');
        const $charsTitle = document.querySelector('.types-wrapper--chars .types-title');

        const $genresElement = $subTypes || $subtypeSelect;
        const $characterisationsElement = $characterisations || $charSelect;
        let allowedGenres = {};
        let allowedCharacterisations = {};

        const init = function () {
            allowedGenres = specifyTypes($genresElement);
            allowedCharacterisations = specifyTypes($characterisationsElement);

            disableSelectOnStart();
            generateCities();
            initTypes();
        };

        const disableSelectOnStart = function () {
            if ($subtypeSelect !== null && $charSelect !== null) {
                changeStateSelect("#subtypeSelect", true);
                changeStateSelect("#charSelect", true);
            }
        };

        const generateCities = function () {
            const $citySelect = document.querySelector("#citySelect");

            if ($citySelect) {
                const hasCities = $citySelect.dataset.hasCities && $citySelect.dataset.hasCities === "true";

                if (!hasCities) {
                    RP6.getFormData.getAllCities(data => {
                        data.forEach(city => $citySelect.appendChild(createZipcodeOption(city)));
                        $("#citySelect").selectpicker('refresh');
                    });
                }
            }
        };

        const initTypes = function () {
            const isFormLight = document.querySelector('.subscribe-form--light') !== null;
            let alreadyShown = false;
            resetTypes();

            if ($types) {
                $types.addEventListener('change', ({ target }) => {
                    const selected = target.options[target.selectedIndex];
                    if (!selected || !selected.value) return;

                    resetTypes();
                    generateTypes(selected.value);
                    //generateStepContent(selected.value);

                    if (!alreadyShown && isFormLight) {
                        $($types).closest('.sub-step').prop("isValid", true);
                        $('.step-footer').removeClass('invisible');
                        alreadyShown = true;
                    }
                });
            }
        };

        //Delete the previous subtypes and checkboxes
        const resetTypes = function () {
            if ($subTypes !== null) {
                $subTypes.innerHTML = '';
            }
            if ($characterisations !== null) {
                $characterisations.innerHTML = '';
            }
            if ($subtypesTitle !== null) {
                $subtypesTitle.classList.remove('active');
                $subtypesTitle.parentNode.classList.remove('active');
            }
            if ($charsTitle !== null) {
                $charsTitle.classList.remove('active');
                $charsTitle.parentNode.classList.remove('active');
            }
            if ($subtypeSelect !== null) {
                $("#subtypeSelect").empty();
                $(".form-group--genres").hide();
                //changeStateSelect("#subtypeSelect", true);
            }
            if ($charSelect !== null) {
                $("#charSelect").empty();
                $(".form-group--char").hide();
                //changeStateSelect("#charSelect", true);
            }
        };

        //Get specific genres or characterisations
        const specifyTypes = function (el) {
            if (!el) return {};

            const keys = Object.keys(el.dataset).filter(key => key.indexOf("sort", 0) !== -1);
            const allowed = {};
            keys.forEach(key => {
                allowed[key.replace("sort", "").toLowerCase()] = el.dataset[key].toLowerCase().split(",");
            });

            return allowed;
        };

        const generateTypes = function (selectedType, subTypeCallback) {
            const sort = selectedType.toLowerCase();

            if ($subTypes !== null || $subtypeSelect !== null) {
                let hasResults = false;

                RP6.getFormData.getSubtypesBySort(selectedType, subtypes => {

                    //Don't show anything if there are less than 2 options.
                    if (!subtypes || subtypes.length < 2) return;
                    subtypes.forEach(function (t) {
                        const key = t.Key.toString().toLowerCase();

                        //If a specific genre is set
                        if (!allowedGenres[sort] || (allowedGenres[sort] && allowedGenres[sort].indexOf(key, 0) !== -1)) {
                            //Don't add "other" (andere) and "unspecified" (standaard)
                            if (key.indexOf("other", 0) === -1 && key.indexOf("unspecified", 0) === -1) {
                                hasResults = true;
                                if ($subTypes !== null) {
                                    $subTypes.appendChild(createCheckbox(t, "MatchCriteria.Genres"));
                                } else if ($subtypeSelect !== null) {
                                    $subtypeSelect.appendChild(createOption(t, "MatchCriteria.Genres"));
                                }
                            }
                        }
                    });

                    if (hasResults && $subtypeSelect !== null) {
                        $(".form-group--genres").show();
                        changeStateSelect("#subtypeSelect", false);
                    }

                    if (hasResults && $subtypesTitle) {
                        $subtypesTitle.classList.add('active'); //Show title
                        $subtypesTitle.parentNode.classList.add('active'); //Add top spacing
                    }

                    hasResults && RP6.subscribe.setStepHeight();
                    if (subTypeCallback) {
                        subTypeCallback("genre", hasResults);
                    }
                });


            }

            if ($characterisations !== null || $charSelect !== null) {
                let hasResults = false;

                RP6.getFormData.getCharacterisationsBySort(selectedType, chars => {

                    //Don't show anything if there are less than 2 options.
                    if (!chars || chars.length < 2) return;
                    chars.forEach(function (c) {
                        const key = c.Key.toString().toLowerCase();

                        //If a specific characterisation is set
                        if (!allowedCharacterisations[sort] || (allowedCharacterisations[sort] && allowedCharacterisations[sort].indexOf(key, 0) !== -1)) {
                            //Don't add "other" (andere) and "unspecified" (standaard)
                            if (key.indexOf("other", 0) === -1 && key.indexOf("unspecified", 0) === -1) {
                                hasResults = true;
                                if ($characterisations !== null) {
                                    $characterisations.appendChild(createCheckbox(c, "MatchCriteria.Characterisations"));
                                } else if ($charSelect !== null) {
                                    $charSelect.appendChild(createOption(c, "MatchCriteria.Characterisations"));
                                }
                            }
                        }
                    });

                    if (hasResults && $charsTitle) {
                        $charsTitle.classList.add('active'); //Show title
                        $charsTitle.parentNode.classList.add('active'); //Add top spacing
                    }

                    if (hasResults && $charSelect !== null) {
                        $(".form-group--char").show();
                        changeStateSelect("#charSelect", false);
                    }

                    hasResults && RP6.subscribe.setStepHeight(); //Change height
                    if (subTypeCallback) {
                        subTypeCallback("characterisation", hasResults);
                    }
                });

            }
        };

        const createCheckbox = (subtype, name) => {
            const $input = document.createElement("input");
            const $label = document.createElement("label");
            const $wrap = document.createElement("div");

            $input.classList.add("custom-control-input");
            $input.setAttribute("id", subtype.Key);
            $input.setAttribute("type", "checkbox");
            $input.setAttribute("name", name);
            $input.setAttribute("value", subtype.Key);

            $label.classList.add("custom-control-label");
            $label.setAttribute("for", subtype.Key);
            $label.innerHTML = subtype.Value;

            $wrap.classList.add("subscribe-checkbox");
            $wrap.appendChild($input);
            $wrap.appendChild($label);

            return $wrap;
        };

        const createOption = (subtype, name) => {
            const $option = document.createElement("option");
            $option.setAttribute("name", name);
            $option.setAttribute("value", subtype.Key);
            $option.innerHTML = subtype.Value;

            return $option;
        };

        const createZipcodeOption = city => {
            const option = document.createElement('option');

            option.value = city.Zipcode;
            option.innerHTML = !$("#citySelect").data("hideZipcodes") ? `${city.Zipcode} - ${city.Name}` : city.Name;
            option.dataset.tokens = `${city.Zipcode} ${city.Name}`;

            return option;
        };

        const changeStateSelect = (id, isDisabled) => {
            $(id).prop('disabled', isDisabled);
            $(id).selectpicker('refresh');
        };

        init();
        RP6.subscribe.fillFormWithQueryString(generateTypes);
    },
    fillFormWithQueryString: function (generateTypes) {
        var qs = location.search.replace('?', '').replaceAll('%20', ' '),
            pairs = qs.split('&'),
            queryStringArray = {};

        if (qs != "") {
            for (var i = 0; i < pairs.length; i++) {
                queryStringArray[pairs[i].split('=')[0]] = pairs[i].split('=')[1];
            }

            //TransactionType
            var transactionType = queryStringArray["transaciontype"];
            if (transactionType != undefined) {
                $("input[name='MatchCriteria.TransactionType'][value='" + transactionType + "']").prop('checked', true);
            }

            //CITY
            var city = queryStringArray["city"];
            if (city != undefined) {
                var isRefreshed = true;
                $('#citySelect').on('refreshed.bs.select', function (e, clickedIndex, isSelected, previousValue) {
                    var getCity = $("#citySelect option").filter(function () { return $.trim($(this).text()) == city });
                    if (getCity.length != 0) {
                        if (isRefreshed) {
                            isRefreshed = false;
                            getCity.prop('selected', true);
                            $('#citySelect').selectpicker('refresh');
                        }
                    }
                });
            }

            //Sort
            var sort = queryStringArray["sort"];
            if (sort != undefined) {
                $('#sorts').selectpicker('val', sort);
                generateTypes(sort, subTypesCompleted);

                function subTypesCompleted(type, hasSubtypes) {
                    if (hasSubtypes) {
                        var subType = queryStringArray[type];
                        if (type == "genre") {
                            $("input[name='MatchCriteria.Genres'][value='" + subType + "']").prop('checked', true);
                        } else if (type == "characterisation") {
                            $("input[name='MatchCriteria.Characterisations'][value='" + subType + "']").prop('checked', true);
                        }
                    }
                };
            }

            $(".step-nr-6").click();
        }
    }
};

RP6.getFormData = {
    getAllCities: callback => {
        const $countryCode = document.getElementById("countryCode");

        const options = {
            country: $countryCode && $countryCode.value || "BE",
            transactiontype: null,
            includeCount: false,
            distinctCityNames: !!$("#citySelect").data("hideZipcodes"),
            distinctCityNameMultipleZipcodes: false,
            includeSubCities: false
        };

        Skarabee.CityAutocomplete("", options, callback);
    },
    getSubtypesBySort: (sort, callback) => {
        Skarabee.GetEstateGenres(sort, callback);
    },
    getCharacterisationsBySort: (sort, callback) => {
        Skarabee.GetEstateCharacterisations(sort, callback);
    }
};

RP6.offer = {
    init: function () {
        //navigate to page if select is toggled
        $('select#sortfields, select#page').on("change", function (e) {
            const selected = e.target.options[e.target.selectedIndex];
            selected && (window.location.href = selected.value);
        });
    },
    //Change the view between list, gallery and map
    changeView: function ({ containerClass = null }) {
        NodeList.prototype.filter = Array.prototype.filter;
        const $btns = document.querySelectorAll(".btn--view:not(.btn--view--sort)");
        const $container = document.querySelector(`.${containerClass}`);
        let isMapLoaded = false;

        const init = function () {
            if (!$container || !$btns) return;
            $btns.forEach(el => el.addEventListener("click", onViewBtnClicked));

            if (RP6_VARS.offerDefaultView) {
                swapViewTo(RP6_VARS.offerDefaultView);
            }
        };

        //Set the containerClass--mode (e.g card-deck--gallery) and the clicked button
        const swapViewTo = view => {
            //Reset
            $($container).removeClass("card-deck--list card-deck--gallery card-deck--map");
            $($btns).removeClass("active");

            //Add correct view
            $($container).addClass(containerClass + "--" + view);
            $(".btn--view[data-view-mode=" + view + "]").addClass("active");

            if (view === "map") {
                if (!isMapLoaded) {
                    loadMap();
                    isMapLoaded = true;
                }
                enableSortings(false);
            } else {
                enableSortings(true);
            }
        };

        const enableSortings = function (enable) {
            if (!enable) {
                $('select#sortfields, select#page').attr('disabled', true);
                $(".pagination > div").addClass("is-disabled");
            } else {
                $('select#sortfields, select#page').attr('disabled', false);
                $(".pagination > div").removeClass("is-disabled");
            }

            $('select#sortfields, select#page').selectpicker('refresh');
        };

        //Click handler
        const onViewBtnClicked = e => {
            e.preventDefault();
            const { currentTarget } = e;
            const { viewMode } = currentTarget.dataset;

            if (viewMode === "map" && $container.classList.contains("card-deck--map")) {
                swapViewTo(RP6_VARS.offerDefaultView);
            } else {
                swapViewTo(viewMode);
            }
        };

        init();
    }
};

RP6.list = {
    init: function () {
        $(document).ready(function () {
            $('.img-popup').magnificPopup({ type: 'image' });
        });
    }
};

RP6.slideshow = {
    init: function (element, overwriteOptions) {
        //'.carousel-inner'
        var options = { ...RP6_VARS };

        $.extend(options, overwriteOptions);

        $(element).slick(options);
    }
};

var maxBedroom = 0;
var maxFloorLevel = 0;
RP6.project = {
    init: function () {
        var jsonModels = RP6_VARS.jsonString;
        //console.log("jsonModels", jsonModels)
        if (RP6_VARS.hasModels) {
            $.each(jsonModels, function (i) {
                $.each(jsonModels[i].Transactions, function (ii) {
                    jsonModels[i].Transactions[ii].Model = jsonModels[i].Name;
                    RP6_VARS.jsonTransactions.push(jsonModels[i].Transactions[ii])
                })
            });
        } else {
            RP6_VARS.jsonTransactions = jsonModels;
        }

        RP6.project.getMax(RP6_VARS.jsonTransactions);
        RP6.project.filterPubsByGlobalSettings();
        RP6.project.updateNumber(".filter-bedrooms--container", "bedrooms");
        RP6.project.updateNumber(".filter-floorlevels--container", "floorlevels");
        RP6.project.checkboxesFilter();
        if (RP6_VARS.hasModels) RP6.project.sortSelect("#models", "Model");
        RP6.project.sortSelect("#sorts", "Sort");
        if (RP6_VARS.MarketingTypes != "") RP6.project.marketingTypeFilter();
    },
    getMax: function (jsonTransactions) {
        $.each(jsonTransactions, function (i, item) {
            maxBedroom = (item.NumberOfBedrooms != null && item.NumberOfBedrooms > maxBedroom ? item.NumberOfBedrooms : maxBedroom);
            maxFloorLevel = (item.FloorLevel != null && item.FloorLevel > maxFloorLevel ? item.FloorLevel : maxFloorLevel);
        });
        //console.log("maxBedrooms", maxBedroom, "maxFloorLevel", maxFloorLevel)
    },
    updateNumber: function (container, type) {
        //Disable text selection
        $(container + " .updateNumber").mousedown(function (e) { e.preventDefault(); });

        //Set min button on disable on startup
        var valueItems = $(container + " .filter-card__counter").text().trim();
        if (valueItems == "/") {
            RP6.project.enableOrDisableButtons(container, false, "min");
        }

        $(container + " .updateNumber").click(function (e) {
            var valueItems = $(container + " .filter-card__counter").text().trim();
            var numberOfItems = (valueItems == "/" ? 0 : parseInt($(container + " .filter-card__counter").text()));
            if (type == "floorlevels") {
                numberOfItems = (valueItems == "/" ? -1 : parseInt($(container + " .filter-card__counter").text()));
            }

            //console.log(numberOfItems);
            if ($(this).hasClass("min")) {
                RP6.project.enableOrDisableButtons(container, true, "plus");

                if (valueItems == "/") {
                    RP6.project.enableOrDisableButtons(container, false, "min");
                    return false;
                }

                numberOfItems = parseInt(numberOfItems - 1);
                $(container + " .filter-card__counter").text(numberOfItems);
            } else if ($(this).hasClass("plus")) {
                RP6.project.enableOrDisableButtons(container, true, "plus");
                RP6.project.enableOrDisableButtons(container, true, "min");

                if ((type == "bedrooms" && (numberOfItems + 1) == maxBedroom) || (type == "floorlevels" && (numberOfItems + 1) == maxFloorLevel)) {
                    RP6.project.enableOrDisableButtons(container, false, "plus");
                }

                numberOfItems = parseInt(numberOfItems + 1);
                $(container + " .filter-card__counter").text(numberOfItems);
            }

            if (type == "bedrooms") {
                if (numberOfItems != 0) RP6_VARS.globalSettings.NumberOfBedrooms = numberOfItems;
                else delete RP6_VARS.globalSettings['NumberOfBedrooms'];

                if (numberOfItems == 0) RP6.project.enableOrDisableButtons(container, false, "min");
            } else if (type == "floorlevels") {
                if (numberOfItems != -1) RP6_VARS.globalSettings.FloorLevel = numberOfItems;
                else delete RP6_VARS.globalSettings['FloorLevel'];

                if (numberOfItems == -1) RP6.project.enableOrDisableButtons(container, false, "min");
            }

            RP6.project.setToZero(container, type);
            RP6.project.filterPubsByGlobalSettings();
        });
    },
    enableOrDisableButtons: function (container, enable, type) {
        if (enable) {
            $(container + " ." + type + ".updateNumber").css("opacity", "1");
            $(container + " ." + type + ".updateNumber").css("pointer-events", "initial");
        } else {
            $(container + " ." + type + ".updateNumber").css("opacity", "0.6");
            $(container + " ." + type + ".updateNumber").css("pointer-events", "none");
        }
    },
    checkboxesFilter: function () {
        $('input[type="checkbox"]:not(.marketingtype-filter)').click(function () {
            var isChecked = $(this).is(":checked");
            RP6.project.updateGlobalSetting($(this).attr('id'), isChecked);
        });
    },
    updateGlobalSetting: function (key, isChecked) {
        if (key != "FloorLevel") {
            if (isChecked) {
                RP6_VARS.globalSettings[key] = true;
                RP6.project.filterPubsByGlobalSettings();
            } else {
                delete RP6_VARS.globalSettings[key];
                RP6.project.filterPubsByGlobalSettings();
            }
        } else {
            if (isChecked) {
                RP6_VARS.globalSettings["FloorLevel"] = 1;
                RP6.project.filterPubsByGlobalSettings();
            } else {
                delete RP6_VARS.globalSettings["FloorLevel"];
                RP6.project.filterPubsByGlobalSettings();
            }
        }
    },
    sortSelect: function (id, property) {
        $(id).change(function () {
            var $option = $(this).find('option:selected');
            var value = $option.val();
            if (value != "") {
                RP6_VARS.globalSettings[property] = value;
                RP6.project.filterPubsByGlobalSettings();
            } else {
                delete RP6_VARS.globalSettings[property];
                RP6.project.filterPubsByGlobalSettings();
            }
        });
    },
    marketingTypeFilter: function () {
        $("input[type='checkbox'].marketingtype-filter").change(function () {
            var isChecked = $(this).is(":checked");
            RP6_VARS.hasMarketingType = isChecked;
            RP6.project.filterPubsByGlobalSettings();
        });
    },
    filterPubsByGlobalSettings: function () {
        RP6_VARS.projectsResult = RP6_VARS.jsonTransactions.filter(RP6.project.search, RP6_VARS.globalSettings);

        if (RP6_VARS.hasMarketingType) {
            var newObject = [];
            $.each(RP6_VARS.MarketingTypes, function (i) {
                var id = RP6_VARS.MarketingTypes[i];
                var result = jQuery.grep(RP6_VARS.projectsResult, function (json, i) {
                    return json.PublicationId == id;
                });
                if (result.length == 1) newObject.push(result[0]);
            });
            RP6_VARS.projectsResult = newObject;
        }

        RP6.project.updateHTML(RP6_VARS.projectsResult);
    },
    updateHTML: function (result) {
        $(".filter-pubs__container .pub-row").removeClass("d-table-row");
        if (result.length != 0) {
            $(".table--project-models .alert-danger").removeClass("d-table-row");
            $(".table--project-models .alert-danger").addClass("d-none");

            $.each(result, function (i) {
                $(".filter-pubs__container .pub-row#" + result[i].Id).addClass("d-table-row");
            });

            $(".filter-pubs__tbody .pub-row.d-table-row").sort(function (a, b) {
                return $(b).data("counter") - $(a).data("counter");
            }).each(function () {
                var elem = $(this);
                elem.remove();
                $(elem).prependTo(".filter-pubs__tbody");
            });
        } else {
            var elem = $(".table--project-models .alert-danger");
            elem.removeClass("d-none");
            elem.addClass("d-table-row");
            elem.remove();
            $(elem).prependTo(".filter-pubs__tbody");
        }
    },
    setToZero: function (container, type) {
        if (type == "bedrooms") {
            if ($(container + " .filter-card__counter").text().trim() == "0") {
                $(container + " .filter-card__counter").text("/");
            }
        } else if (type == "floorlevels") {
            if ($(container + " .filter-card__counter").text().trim() == "-1") {
                $(container + " .filter-card__counter").text("/");
            }
        }
    },
    search: function (jsonTransactions) {
        return Object.keys(this).every((key) => (
            jsonTransactions[key] === this[key]
        ));
    },
    openPopup: function () {
        $('.pub-row').magnificPopup({
            type: 'ajax',
            overflowY: 'scroll',
            showCloseBtn: false,
            modal: true,
            callbacks: {
                ajaxContentAdded: function () {
                    $(".close__button").click(function () {
                        $.magnificPopup.close();
                    });
                }
            }
        });
    }
};

RP6.reservations = {
    init: function (lang, useCalendar) {
        var json = RP6.reservations.convertStringToDates(JSON.parse(localStorage.getItem("reservations")));
        _lang = lang;

        if (useCalendar == "True") {
            RP6.reservations.initCalendar(json);
        } else {
            RP6.reservations.initTimeSlotLayout(json);
        }
    },
    initTimeSlotLayout: function (json) {
        //Add dates in selectbox
        RP6.reservations.loopJsonInSelectbox(json);

        if (json.length != 1) {
            $("#dates").change(function (e) {
                RP6.reservations.loadTimeslots(this.value, json);
                RP6.reservations.setValues("", "", "", "", "");
                $(".timeslot:not(.timeslot--unavailable)").eq(0).trigger("click");
            });
        } else {
            $("#dates").attr('disabled', 'disabled');
        }
    },
    loopJsonInSelectbox: function (json) {
        $.each(json, function (i) {
            $("#dates").append("<option value='" + json[i].ActionID + "'>" + json[i].DateFrom.convertToLocaleDateString(_lang) + "</option>");
            if (i == 0) {
                RP6.reservations.loadTimeslots(json[i].ActionID, json);
            }
            if (i + 1 == json.length) {
                RP6.reservations.selectDateAndTime(json);
            }
        })
    },
    convertStringToDates: function (json) {
        json.map(function (j, index) {
            j.DateFrom = new Date(j.DateFrom.convertStringToDate());
            j.DateTo = new Date(j.DateTo.convertStringToDate());

            j.ReservationSlots.map(function (jj) {
                jj.DateFrom = new Date(jj.DateFrom.convertStringToDate());
                jj.DateTo = new Date(jj.DateTo.convertStringToDate());
            });
        });

        return json;
    },
    selectDateAndTime: function (json) {
        if ($("#ReservationContact_ActionID").val() != 0 && $("#ReservationContact_ActionID").val() != "") {
            $('option[value="' + $("#ReservationContact_ActionID").val() + '"]').prop("selected", true);
            RP6.reservations.loadTimeslots($("#ReservationContact_ActionID").val(), json);
            if ($("#ReservationContact_timeslotID").val() != "" && $("#ReservationContact_timeslotID").val() != 0) {
                $(".timeslot[data-id='" + $("#ReservationContact_timeslotID").val() + "']").trigger("click");
            }
        } else {
            $(".timeslot:not(.timeslot--unavailable)").eq(0).trigger("click");
        }
    },
    loadTimeslots: function (actionID, json) {
        $(".timeslots").empty();

        var selectedObject = json.filter(function (j, i) {
            return j.ActionID == actionID;
        });

        var timeslots = selectedObject[0].ReservationSlots;
        var timeDifference = Math.floor(((timeslots[0].DateTo - timeslots[0].DateFrom) / 1000) / 60);
        var classTimeslot = "";

        if (timeDifference <= 5) {
            classTimeslot = "timeslot--small"
        } else if (timeDifference > 5 && timeDifference <= 45) {
            classTimeslot = "timeslot--medium";
        } else {
            classTimeslot = "timeslot--large";
        }

        $.each(timeslots, function (i) {
            var ts = timeslots[i];
            if (ts.MaxVisits == 0) {
                $(".timeslots").append("<div data-id='" + ts.ID + "' data-datefrom='' data-dateto='' class='alert timeslot alert-success " + classTimeslot + "'>" + ts.DateFrom.convertToHourMinutes() + " - " + ts.DateTo.convertToHourMinutes() + "</div>")
            } else {
                $(".timeslots").append("<div data-id='" + ts.ID + "' data-datefrom='' data-dateto='' class='alert timeslot " + (ts.Available == false ? "timeslot--unavailable alert-danger " : "alert-success ") + classTimeslot + "'>" + (ts.Available == false ? "<span>Gereserveerd</span>" : "") + ts.DateFrom.convertToHourMinutes() + " - " + ts.DateTo.convertToHourMinutes() + "</div>")
            }
        });

        RP6.reservations.chooseTime(selectedObject[0]);
    },
    chooseTime: function (selectedObject) {
        $(".timeslot:not(.timeslot--unavailable)").click(function () {
            $(".timeslot:not(.timeslot--unavailable)").removeClass("timeslot--active");
            $(this).addClass("timeslot--active");

            var id = $(this).data("id");
            var selectedTime = selectedObject.ReservationSlots.filter(function (j, i) {
                return j.ID == id;
            });

            if (selectedTime[0].MaxVisits == 0) {
                $(".timeslot--status").hide();
            } else {
                $(".timeslot--status").show();
            }

            RP6.reservations.setValues(
                selectedObject.ActionID,
                selectedTime[0].DateFrom.convertToDayMonthYear() + " " + selectedTime[0].DateFrom.convertToHourMinutes(),
                selectedTime[0].DateTo.convertToDayMonthYear() + " " + selectedTime[0].DateTo.convertToHourMinutes(),
                selectedTime[0].DateFrom.convertToLocaleDateString(_lang) + " " + selectedTime[0].DateFrom.convertToHourMinutes(),
                selectedTime[0].ID
            );
        });
    },
    initCalendar: function (json) {
        var allStringifiedDates = [];
        $.each(json, function (i) {
            allStringifiedDates.push(json[i].DateFrom.convertToDayMonthYear());
        });

        var firstDate = json[0].DateFrom.convertToDayMonthYear();
        var allowedTimes = [];
        $.each(json[0].ReservationSlots, function (i) {
            allowedTimes.push(json[0].ReservationSlots[i].DateFrom.convertToHourMinutes());
        });

        var d = new Date();
        var n = d.getFullYear();

        jQuery.datetimepicker.setLocale(_lang);
        $("#field_Bezoekmoment").datetimepicker({
            parentID: '#frm_visit',
            formatDate: 'd/m/Y',
            formatTime: 'H:i',
            todayButton: false,
            dayOfWeekStart: 1,
            yearStart: n,
            yearEnd: n + 1,
            inline: true,
            mask: true,
            scrollTime: true,
            scrollMonth: false,
            datepicker: true,
            startDate: firstDate,
            allowTimes: allowedTimes,
            allowDates: allStringifiedDates,

            onSelectDate: function (ct, $i) {
                RP6.reservations.setValues("", "", "", "", "", "&nbsp;");

                var selectedData = ct.convertToDayMonthYear();
                var getChosenData = json.filter(function (timeslot, i) {
                    if (selectedData == timeslot.DateTo.convertToDayMonthYear()) {
                        return timeslot;
                    }
                    return null;
                });

                if (getChosenData != null) {
                    var getTimeslots = getChosenData[0].ReservationSlots;
                    allowedTimes = [];
                    $.each(getTimeslots, function (i) {
                        allowedTimes.push(getTimeslots[i].DateFrom.convertToHourMinutes());
                    });
                    this.setOptions({
                        allowTimes: allowedTimes
                    });
                }
            },

            onSelectTime: function (ct, $i) {
                var selectedData = ct.convertToDayMonthYear();
                var getChosenData = json.filter(function (timeslot, i) {
                    if (selectedData == timeslot.DateTo.convertToDayMonthYear()) {
                        return timeslot;
                    }
                    return null;
                });

                if (getChosenData != null) {
                    var selectedObject = null;
                    var getTimeslots = getChosenData[0].ReservationSlots;
                    var selectedTimeslot = ct.convertToHourMinutes();

                    $.each(getTimeslots, function (i) {
                        if (selectedTimeslot == getTimeslots[i].DateFrom.convertToHourMinutes()) {
                            selectedObject = getTimeslots[i];
                            return false;
                        }
                    });

                    RP6.reservations.saveSelectedTime(getChosenData[0], selectedObject);
                }
            },

            onGenerate: function (ct) {
                RP6.reservations.bookedTimes(ct, json, allStringifiedDates);
                RP6.reservations.disableMonthArrows(allStringifiedDates);
            }

        });
    },
    saveSelectedTime: function (getChosenData, selectedObject) {
        RP6.reservations.setValues(
            getChosenData.ActionID,
            selectedObject.DateFrom.convertToDayMonthYear() + " " + selectedObject.DateFrom.convertToHourMinutes(),
            selectedObject.DateTo.convertToDayMonthYear() + " " + selectedObject.DateTo.convertToHourMinutes(),
            getChosenData.DateFrom.convertToLocaleDateString(_lang) + " " + selectedObject.DateFrom.convertToHourMinutes(),
            selectedObject.ID,
            getChosenData.DateFrom.convertToLocaleDateString(_lang) + " " + selectedObject.DateFrom.convertToHourMinutes() + " - " + selectedObject.DateTo.convertToHourMinutes()
        );
    },
    bookedTimes: function (ct, json, allStringifiedDates) {
        if ($.inArray(ct.convertToDayMonthYear(), allStringifiedDates) != -1) {
            var selectedData = ct.convertToDayMonthYear();
            var getChosenData = json.filter(function (timeslot, i) {
                if (selectedData == timeslot.DateTo.convertToDayMonthYear()) {
                    return timeslot;
                }
                return null;
            });

            if (getChosenData != null) {
                var getTimeslots = getChosenData[0].ReservationSlots;
                $.each(getTimeslots, function (i) {
                    if (getTimeslots[i].Visitcount != 0) {
                        if (getTimeslots[i].Visitcount == getTimeslots[i].MaxVisits) {
                            var hour = getTimeslots[i].DateFrom.getHours()
                            var minute = getTimeslots[i].DateFrom.getMinutes();
                            $('.xdsoft_time[data-hour="' + hour + '"][data-minute="' + minute + '"]').addClass("time-is-full");
                        }
                    }
                });
            }
        }
    },
    disableMonthArrows: function (allStringifiedDates) {
        var countDates = allStringifiedDates.length;
        if (countDates >= 2) {
            var firstDate = allStringifiedDates[0].split("/");
            var lastDate = allStringifiedDates[countDates - 1].split("/");

            var currentMonth = parseInt($(".xdsoft_label.xdsoft_month .xdsoft_monthselect .xdsoft_option.xdsoft_current").data("value") + 1);
            var currentYear = $(".xdsoft_label.xdsoft_year .xdsoft_yearselect .xdsoft_option.xdsoft_current").data("value");

            if (Number(firstDate[1]).toString() == currentMonth && Number(firstDate[2]).toString() == currentYear) {
                $(".xdsoft_monthpicker .xdsoft_prev").hide();
            } else {
                $(".xdsoft_monthpicker .xdsoft_prev").show();
            }

            if (Number(lastDate[1]).toString() == currentMonth && Number(lastDate[2]).toString() == currentYear) {
                $(".xdsoft_monthpicker .xdsoft_next").hide();
            } else {
                $(".xdsoft_monthpicker .xdsoft_next").show();
            }
        } else if (countDates == 1) {
            $(".xdsoft_monthpicker .xdsoft_prev").hide();
            $(".xdsoft_monthpicker .xdsoft_next").hide();
        }
    },
    setValues: function (actionID, dateFrom, dateTo, date, timeslotID, stringifiedChosenDate = "") {
        $("#ReservationContact_ActionID").val(actionID);
        $("#ReservationContact_DateFrom").val(dateFrom);
        $("#ReservationContact_DateTo").val(dateTo);
        $("#ReservationContact_ReservedTime").val(date);
        $("#ReservationContact_timeslotID").val(timeslotID);
        $(".lbl_chosen_date_string").html(stringifiedChosenDate);
    }
}

String.prototype.convertStringToDate = function () {
    var newDate = new Date(parseInt(this.replace(/\D/g, '')));
    return newDate;
}

Date.prototype.convertToLocaleDateString = function (lang) {
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    return this.toLocaleDateString(lang, options);
}

Date.prototype.convertToHourMinutes = function () {
    return this.getHours() + ":" + (this.getMinutes() < 10 ? '0' : '') + this.getMinutes();
}

Date.prototype.convertToDayMonthYear = function () {
    var day = this.getDate();
    var month = parseInt(this.getMonth() + 1);
    var year = this.getFullYear();
    return (day < 10 ? "0" : "") + day + "/" + (month < 10 ? "0" : "") + month + "/" + year;
}

/* jshint ignore:end */
